import React from 'react'
import { PASSWORD_RULES } from '../../utils/passwordRules'

export default function PasswordStrengthRules({ password }) {
  if (!password) return null
  return (
    <ul
      style={{
        listStyle: 'none',
        margin: '6px 0 4px',
        padding: '8px 12px',
        fontSize: 12,
        background: '#fafafa',
        border: '1px solid #eee',
        borderRadius: 4,
      }}
    >
      {PASSWORD_RULES.map(rule => {
        const passed = rule.test(password)
        return (
          <li
            key={rule.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 4,
              color: passed ? '#27ae60' : '#e74c3c',
              lineHeight: '1.4',
            }}
          >
            <i
              className={`fa ${passed ? 'fa-check-circle' : 'fa-times-circle'}`}
              style={{ marginRight: 7, fontSize: 13, flexShrink: 0 }}
            />
            {rule.label}
          </li>
        )
      })}
    </ul>
  )
}
